<template>
  <div>
    <h5 class="text-center"> {{ computeCaption(fields_en['a_security_code_was_sent_to'], $store.state.lang.value.toLowerCase()) }} {{ this.$store.state.results.user['sendTo'] }}</h5>
    <br>
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <form @submit.prevent="triggerNextTab">
            <label for="confirmationCode">{{ computeCaption(fields_en['please_input_the_code_provided_to_you'], $store.state.lang.value.toLowerCase())}}</label>
            <input class="form-control"
                  data-vv-as="Security code"
                  id="confirmationCode"
                  type="number"
                  name="confirmationCode"
                  v-validate="modelValidations.confirmationCode"
                  v-model="model.confirmationCode"
                  placeholder="ex: 12345678"
                   onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
            />
          </form>
          <small class="text-danger" v-show="confirmationCode.invalid">
            {{ getError('confirmationCode') && computeCaption(getError('confirmationCode'), $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import axios from 'axios'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  export default {
    data () {
      return {
        fields_en: {
          a_security_code_was_sent_to: 'A security code was sent to:',
          please_input_the_code_provided_to_you: 'Please input the code provided to you:'
        },
        model: {
          confirmationCode: ''
        },
        modelValidations: {
          confirmationCode: {
            min: 6,
            required: true
          }
        },
        value: null
      }
    },
    mixins: [TranslationsUtils],
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      triggerNextTab () {
        this.$emit('nextTab')
      },
      validate () {
        return new Promise((resolve, reject) => {
          axios.get(process.env.SERVER_URI + '/validate/confirmation_code/' + this.model.confirmationCode + '/' + this.$store.state.results.user.code)
          .then(async (response) => {
            if (response.data === false) {
              this.$validator.errors.add({field: 'confirmationCode', msg: 'Invalid Code!'})
              let field = this.$validator._resolveField('confirmationCode')
              field.setFlags({invalid: true})
              reject(new Error('Invalid code!!'))
            } else {
              await axios.get(process.env.SERVER_URI + '/results/' + this.model.confirmationCode + '/' + this.$store.state.results.user.code + '/' + this.$store.state.results.site.site_code + '/' + this.$store.state.results.user.firstName + '/' + this.$store.state.results.user.lastName).then((response) => {
                this.$store.state.results.user.result = response.data
                this.$emit('result', response.data)
              }).catch(() => {
                console.log('error')
              })
            }
            resolve(true)
          })
          .catch(() => {
            this.$validator.errors.add({field: 'confirmationCode', msg: 'Invalid Code or server issues!'})
            let field = this.$validator._resolveField('confirmationCode')
            field.setFlags({invalid: true})
            reject(new Error('Invalid code!!'))
          })
        })
      }
    },
    computed: {
      ...mapFields(['confirmationCode'])
    }
  }
</script>
<style scoped>

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  #site-code{
    text-transform: uppercase;
  }

  img {
    width: 20px;
    height: 20px;
  }

  .prefix {
    margin-top: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Results/Wizard/CheckConfirmationNumber.vue